import { useTranslation } from 'react-i18next'
import { styled, Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'
import useContent from '../../hooks/backoffice/useContent'
import DataTable, { ColumnSettingType, RenderColumnAction } from '../../control/dataTable/DataTable'
import EditAction from '../../control/dataTable/renderAction/EditAction'

type ManageContentProps = {}

const ManageContent = (props: ManageContentProps) => {
    const { onClickEdit, data, totalItem, paramServerSide } = useContent()
    const { t } = useTranslation()
    const classes = useStyles()

    const columnOptions: ColumnSettingType[] = [
        {
            dataKey: 'contentTypeName',
            label: 'หมวด',
            align: 'left',
        },
        {
            dataKey: 'title',
            label: 'หัวข้อ',
            align: 'left',
        },
        {
            dataKey: 'updateDate',
            label: 'แก้ไขล่าสุด',
            align: 'center',
        },
        {
            dataKey: 'action',
            label: 'จัดการ',
            align: 'center',
            type: 'action',
            render: (row: any) => (
                <RenderColumnAction>
                    <EditAction data={row} onClick={(data: any) => onClickEdit(data)} />
                </RenderColumnAction>
            ),
        },
    ]

    return (
        <>
            <StyledDivHeader>
                <StyledTypoHeader variant="h6">{t('MENU.CONTENT_MANAGEMENT')}</StyledTypoHeader>
            </StyledDivHeader>
            <StyledDivContent>
                <StyledDivSearchResultHeader>
                    <StyledDivSearchResultTotal>
                        <StyledTypoSearchResultTitle>{`รายการ${t(
                            'LABEL.BACKOFFICE.CONTENT.TITLE',
                        )}`}</StyledTypoSearchResultTitle>
                        <StyledTypoSearchResultAmount>{`(${totalItem} รายการ)`}</StyledTypoSearchResultAmount>
                    </StyledDivSearchResultTotal>
                </StyledDivSearchResultHeader>
                <DataTable<any>
                    columnOptions={columnOptions}
                    dataSource={data}
                    maxHeight={500}
                    totalItem={totalItem}
                    rowsPerPage={totalItem >= paramServerSide.rowPerPage ? paramServerSide.rowPerPage : totalItem}
                    sortField={paramServerSide.sortField}
                    sortType={paramServerSide.sortType}
                    pageNumber={paramServerSide.pageNumber}
                />
            </StyledDivContent>
        </>
    )
}

export default ManageContent

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    divButton: {
        [theme.breakpoints.up('lg')]: {
            paddingTop: '24px',
        },
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            justifyContent: 'end',
        },
    },
    button: {
        width: '125px',
        minHeight: '37px',
    },
}))

const StyledDivHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingBottom: '15px',
}))

const StyledTypoHeader = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
}))

const StyledDivContent = styled('div')(({ theme }) => ({
    width: '100%',
    padding: '15px 30px',
    borderRadius: '5px',
    backgroundColor: theme.palette.text.secondary,
    boxShadow: theme.palette.getContrastText('shadow-bottom-gray'),
}))

const StyledDivSearchResultHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    marginBottom: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
}))

const StyledDivSearchResultTotal = styled('div')(({ theme }) => ({
    display: 'flex',
}))

const StyledTypoSearchResultTitle = styled(Typography)(({ theme }) => ({
    marginRight: '5px',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
}))

const StyledTypoSearchResultAmount = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))
